import { ILectioPlugin } from "./Types";

export class PluginToolbarShortcutsDisplay implements ILectioPlugin {
	public Init(): void {
		// Keyboard shortcut descriptions in toolbar button tooltips.
		CKEDITOR.plugins.add('toolbarshortcutsdisplay', {
			init: editorOuter => {
				const editor = editorOuter;
				editor.on('uiSpace', () => {
					//Dette er et KÆMPE hack
					editor.on("instanceReady", ei => {
						const fmt: any = ei.editor.ui.get('LectioFormat');
						const render = fmt.onOpen;
						fmt.onOpen = function(...args: any[]) {
							render.call(this, ...args);
							const s = $('.cke_panel_frame').contents().find('.cke_panel_block');
							$("a[title='Overskrift 1']", s).attr('title', 'Overskrift 1 (Ctrl+Alt+1)');
							$("a[title='Overskrift 2']", s).attr('title', 'Overskrift 2 (Ctrl+Alt+2)');
							$("a[title='Overskrift 3']", s).attr('title', 'Overskrift 3 (Ctrl+Alt+3)');
							$("a[title='Normal']", s).attr('title', 'Normal (Ctrl+Shift+N)');
						};
					});
				}, null, null, 5);
			}
		});
	}
}
